package org.example.project.components

import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import kotlinx.coroutines.launch
import org.example.project.FirebaseManager
import org.example.project.GetOrgInfoResult
import org.example.project.PrimaryColor
import org.example.project.SystemProfileDocument

@Composable
fun QueryOrgSection(
    onResult: (SystemProfileDocument?) -> Unit
) {
    val scope = rememberCoroutineScope()
    var queriedOrgEmail by remember { mutableStateOf("") }
    var isQueryingOrg by remember { mutableStateOf(false) }
    var queryOrgMessage by remember { mutableStateOf<String?>(null) }

    Card(
        colors = CardDefaults.cardColors(containerColor = Color.White),
        elevation = CardDefaults.cardElevation(defaultElevation = 2.dp)
    ) {
        Column(modifier = Modifier.padding(24.dp).fillMaxWidth()) {
            Text(
                text = "Account Lookup",
                style = MaterialTheme.typography.titleMedium,
                fontWeight = FontWeight.Bold,
                color = Color(0xFF64748B)
            )
            Spacer(modifier = Modifier.height(16.dp))
            
            OutlinedTextField(
                value = queriedOrgEmail,
                onValueChange = { queriedOrgEmail = it },
                label = { Text("Search by email") },
                placeholder = { Text("organization@example.com") },
                modifier = Modifier.fillMaxWidth(),
                singleLine = true,
                colors = OutlinedTextFieldDefaults.colors(
                    focusedBorderColor = PrimaryColor,
                    unfocusedBorderColor = Color(0xFFE2E8F0)
                )
            )
            Spacer(modifier = Modifier.height(16.dp))
            Button(
                onClick = {
                    if (queriedOrgEmail.isNotBlank()) {
                        scope.launch {
                            isQueryingOrg = true
                            queryOrgMessage = null
                            val result = FirebaseManager.getOrgInfo(queriedOrgEmail)
                            when (result) {
                                is GetOrgInfoResult.Success -> {
                                    onResult(result.data)
                                    queryOrgMessage = "Account found successfully."
                                }
                                is GetOrgInfoResult.Error -> {
                                    onResult(null)
                                    queryOrgMessage = "Error: ${result.message}"
                                }
                            }
                            isQueryingOrg = false
                        }
                    }
                },
                enabled = !isQueryingOrg && queriedOrgEmail.isNotBlank(),
                modifier = Modifier.fillMaxWidth(),
                colors = ButtonDefaults.buttonColors(containerColor = PrimaryColor),
                shape = MaterialTheme.shapes.medium
            ) {
                if (isQueryingOrg) {
                    CircularProgressIndicator(modifier = Modifier.size(20.dp), color = Color.White, strokeWidth = 2.dp)
                } else {
                    Text("Search", fontWeight = FontWeight.Bold)
                }
            }
            
            if (queryOrgMessage != null) {
                val isError = queryOrgMessage!!.startsWith("Error")
                Spacer(modifier = Modifier.height(16.dp))
                Surface(
                    color = if (isError) Color(0xFFFEF2F2) else Color(0xFFF0FDF4),
                    shape = MaterialTheme.shapes.small,
                    modifier = Modifier.fillMaxWidth()
                ) {
                    Row(
                        modifier = Modifier.padding(16.dp),
                        verticalAlignment = androidx.compose.ui.Alignment.CenterVertically
                    ) {
                        Text(
                            text = queryOrgMessage!!,
                            color = if (isError) Color(0xFFDC2626) else Color(0xFF16A34A),
                            style = MaterialTheme.typography.bodySmall,
                            fontWeight = FontWeight.Medium
                        )
                    }
                }
            }
        }
    }
}
